import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
const sizeMap = {
    sm: { box: 'h-9 w-9', text: 'text-[15px]' },
    md: { box: 'h-10 w-10', text: 'text-base' },
    lg: { box: 'h-11 w-11', text: 'text-lg' },
};
/**
 * Compact brand mark — a deep emerald rounded square with a subtle inset
 * concentric ring, used as the app icon in the sidebar and mobile header.
 */
export function BrandMark({ size = 'md', className }) {
    const s = sizeMap[size];
    return (_jsxs("div", { className: cn('relative flex shrink-0 items-center justify-center overflow-hidden rounded-xl bg-gradient-to-br from-primary to-emerald-900 text-primary-foreground shadow-md shadow-primary/20', s.box, className), "aria-hidden": true, children: [_jsx("span", { className: "absolute inset-1 rounded-lg ring-1 ring-inset ring-white/15" }), _jsx("span", { className: cn('relative font-bold tracking-tight', s.text), children: "G" }), _jsx("span", { className: "absolute -right-2 -top-2 h-5 w-5 rounded-full bg-emerald-400/30 blur-md" })] }));
}
